import { createEvoClient, getExternalProviders, requestExternalCoupon } from "@jti/evo-client";
import { getConfig } from "@jti/fe-common";
import type { GetProvidersResponseType, RequestCouponSuccessResponseType } from "@jti/rest-api-types";

import { getUser } from "../../utils";

export class CouponsApi {
  readonly name = "CouponsApi";
  private readonly client;
  private static instance: CouponsApi | null = null;

  private constructor(baseUrl: string, tenantToken: string, recaptchaId: string, ciamToken: string) {
    this.client = createEvoClient({
      baseUrl,
      ciamToken,
      recaptchaId,
      tenantToken,
      throwOnError: true,
    });
  }

  static init(): CouponsApi {
    const config = getConfig();
    const user = getUser();

    if (!CouponsApi.instance) {
      CouponsApi.instance = new CouponsApi(
        config.EVO_DOMAIN,
        config.EVO_TENANT,
        config["X-RECAPTCHA-ID"],
        user.ciam_token
      );
    }
    return CouponsApi.instance;
  }

  async getProviders(country: string): Promise<GetProvidersResponseType> {
    const { data } = await getExternalProviders({
      client: this.client,
      path: {
        country,
      },
    });
    return data as GetProvidersResponseType;
  }

  async requestCoupon(code: string): Promise<RequestCouponSuccessResponseType> {
    const { data } = await requestExternalCoupon({
      client: this.client,
      path: {
        provider: code,
      },
    });

    return data as RequestCouponSuccessResponseType;
  }
}
